module.exports = __webpack_public_path__ + "img/mask-group.87427ad3.png";